export const colorArray = [
    '#FFFFFF',
    '#BB0000',
    '#AA0000',
    '#990000',
    '#880000',
    '#770000',
    '#660000',
    '#550000',
    '#440000',
    '#330000',
];
